import { getRects } from "../../utils";

import { toArray } from "../../../../../../utils/to";
import * as constants from ".././../../constants";
import type {
	FlippedElementPositionsAfterUpdate,
	FlippedElementPositionDatumAfterUpdate,
} from "./types";

export const getFlippedElementPositionsAfterUpdate = ({
	element,
}: {
	element: HTMLElement;
}): FlippedElementPositionsAfterUpdate => {
	const flippedElements = toArray<HTMLElement>(
		element.querySelectorAll(`[${constants.DATA_FLIP_ID}]`),
	);
	const positionArray = getRects(flippedElements).map(([child, childBCR]) => {
		//Why we are using getComputedStyle?
		const computedStyle = window.getComputedStyle(child);
		return [
			child.dataset.flipId!,
			{
				element: child,
				rect: childBCR,
				opacity: parseFloat(computedStyle.opacity || "1"),
				transform: computedStyle.transform,
			},
		];
	}) as [string, FlippedElementPositionDatumAfterUpdate][];

	return positionArray.reduce<Record<string, FlippedElementPositionDatumAfterUpdate>>(
		(map, [flipId, datum]) => {
			map[flipId] = datum;
			return map;
		},
		{},
	);
};
